import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment as env } from "src/environments/environment";
import { FiltroInterface, InterfaceAmsPage, InterfaceArquivo } from '../domain/interface';
import { ResponseFileDTO } from '../domain/file';

@Injectable()
export class ConsultaService {

    constructor(private http: HttpClient) { }

    httpOptions = { headers: new HttpHeaders({ 'Content-Type': 'application/json' }) };

    buscarListaInterfaceArquivo() {
        return this.http.get<InterfaceArquivo[]>(`${env.apiUrlBase}/gestao-interface-ams/v1/lista-arquivos`)
            .toPromise()
            .then(res => res as InterfaceArquivo[])
            .then(data => data);
    }

    buscarDetalhesInterfaceAms(id: number, tamanhoPagina?: number, numPagina?: number) {
        let url = `${env.apiUrlBase}/gestao-interface-ams/v1/log/${id}/detalhes`;
        let controleUrl = url.length;

        if (tamanhoPagina !== null && tamanhoPagina !== undefined) {
            url = url.concat(`${url.length === controleUrl ? '?' : '&'}size=${tamanhoPagina}`);
        }
        if (numPagina !== null && numPagina !== undefined) {
            url = url.concat(`${url.length === controleUrl ? '?' : '&'}page=${numPagina}`);
        }
        if (tamanhoPagina == null) {
            url = url.concat(`${url.length === controleUrl ? '?' : '&'}size=10`);
        }
        if (numPagina == null) {
            url = url.concat(`${url.length === controleUrl ? '?' : '&'}page=0`);
        }

        return this.http.get<InterfaceAmsPage>(`${url}`)
            .toPromise()
            .then(res => res as InterfaceAmsPage)
            .then(data => data);
    }
    buscaInterfaceAmsFiltro(filtroInterface: FiltroInterface) {

        let url = `${env.apiUrlBase}/gestao-interface-ams/v1/new-logs`;
        
        let controleUrl = url.length;

        if (filtroInterface.tamanhoPagina !== null && filtroInterface.tamanhoPagina !== undefined) {
            url = url.concat(`${url.length === controleUrl ? '?' : '&'}size=${filtroInterface.tamanhoPagina}`);
        }
        if (filtroInterface.numPagina !== null && filtroInterface.numPagina !== undefined) {
            url = url.concat(`${url.length === controleUrl ? '?' : '&'}page=${filtroInterface.numPagina}`);
        }
        if (filtroInterface.tamanhoPagina == null) {
            url = url.concat(`${url.length === controleUrl ? '?' : '&'}size=10`);
        }
        if (filtroInterface.numPagina == null) {
            url = url.concat(`${url.length === controleUrl ? '?' : '&'}page=0`);
        }
        if (filtroInterface.dataInicio !== null && filtroInterface.dataInicio !== undefined) {
            url = url.concat(`${url.length === controleUrl ? '?' : '&'}dataInclusao=${filtroInterface.dataInicio.toISOString().split('T')[0]}`);
        }
        if (filtroInterface.dataTermino !== null && filtroInterface.dataTermino !== undefined) {
            let _dataTermino: Date = this.addDiasData(filtroInterface.dataTermino, 1);
            url = url.concat(`${url.length === controleUrl ? '?' : '&'}dataInclusao=${_dataTermino.toISOString().split('T')[0]}`);
        }
        if (filtroInterface.interfaceArquivo !== null && filtroInterface.interfaceArquivo !== undefined && filtroInterface.interfaceArquivo.codigoArquivoSam.toString().trim() !== '') {
            url = url.concat(`${url.length === controleUrl ? '?' : '&'}siglaTabela=${filtroInterface.interfaceArquivo.codigoArquivoSam.toString().trim()}`);
        }
        if (filtroInterface.tipoMovimento !== null && filtroInterface.tipoMovimento !== undefined) {
            url = url.concat(`${url.length === controleUrl ? '?' : '&'}status=${filtroInterface.tipoMovimento.code}`);
        }
        if (filtroInterface.situacaoProcessamento !== null && filtroInterface.situacaoProcessamento !== undefined && filtroInterface.situacaoProcessamento.code == "P") {
            url = url.concat(`${url.length === controleUrl ? '?' : '&'}dataRetorno=0001-01-01`);
        }
        if (filtroInterface.situacaoProcessamento !== null && filtroInterface.situacaoProcessamento !== undefined && filtroInterface.situacaoProcessamento.code == "S") {
            url = url.concat(`${url.length === controleUrl ? '?' : '&'}qtdeErros=0`);
        }
        if (filtroInterface.situacaoProcessamento !== null && filtroInterface.situacaoProcessamento !== undefined && filtroInterface.situacaoProcessamento.code == "E") {
            url = url.concat(`${url.length === controleUrl ? '?' : '&'}qtdeErros=1`);
        }

        return this.http.get<InterfaceAmsPage>(`${url}`)
            .toPromise()
            .then(res => res as InterfaceAmsPage)
            .then(data => data);
    }

    getDownloadArquivoStream(nomeArquivo: string, storageInterfaces: boolean) {

        let url = `${env.apiUrlBase}/file/v1/download`;
        let controleUrl = url.length;
        url = url.concat(`?nomeArquivo=${nomeArquivo}&storageInterface=${storageInterfaces ? 'S' : 'N'}`)
        return this.http.get(`${url}`, {
            responseType: 'arraybuffer'
        }
        ).toPromise()
            .then(data => data)

        //.then(response => {this.downLoadFile(response, nomeArquivo)});

    }

    getDownloadExcel(idInterface: number, nomeArquivo: string, storageInterfaces: boolean) {
        let url = `${env.apiUrlBase}/excel/v1/gerar/detalhado/tela`;
        url = url.concat(`?idInterface=${idInterface}&nomeArquivo=${nomeArquivo}&storageInterfaces=${storageInterfaces ? 'S' : 'N'}`)
        return this.http.get(`${url}`, {
            responseType: 'arraybuffer'
        }
        ).toPromise().then(data => data);
    }

    getDownloadExcelConsolidadoEmTela(idInterface: number, nomeArquivo: string, storageInterfaces: boolean) {
        let url = `${env.apiUrlBase}/excel/v1/gerar/consolidado/tela`;
        url = url.concat(`?idInterface=${idInterface}&nomeArquivo=${nomeArquivo}&storageInterfaces=${storageInterfaces ? 'S' : 'N'}`)
        return this.http.get(`${url}`, {
            responseType: 'arraybuffer'
        }
        ).toPromise().then(data => data)
    }
    
    getDownloadExcelConsolidado(idInterface: number, email: string) {
        let url = `${env.apiUrlBase}/excel/v1/gerar/consolidado/email`;
        url = url.concat(`?idInterface=${idInterface}&email=${email}`)
        return this.http.get(url).subscribe();
    }

    downLoadFile(data: ArrayBuffer, type: string) {
        const fileName = type;
        const a = document.createElement('a');
        document.body.appendChild(a); a.href = 'display: none';
        const blob = new Blob([data], { type: type });
        const url = window.URL.createObjectURL(blob);
        a.href = url;
        a.download = fileName;
        a.click();
        window.URL.revokeObjectURL(url);
    }

    checkFile(idInterface: number) {
        let url = `${env.apiUrlBase}/file/v1/download-file-original-check`;
        url = url.concat(`?idInterface=${idInterface}`)

        return this.http.get<ResponseFileDTO>(url)
            .toPromise()
            .then(res => res as ResponseFileDTO)
            .then(data => data);
    }

    addDiasData(data: Date, dias: number) {
        const result = new Date(data);
        result.setDate(result.getDate() + dias);
        return result;
    }

    enviaExcelEmail(idInterface: number, nomeArquivo: string, storageInterfaces: boolean, email: string) {
        let url = `${env.apiUrlBase}/excel/v1/gerar/detalhado/email`;
        url = url.concat(`?idInterface=${idInterface}&nomeArquivo=${nomeArquivo}&storageInterfaces=${storageInterfaces ? 'S' : 'N'}&email=${email}`)
        return this.http.get(`${url}`).subscribe();
    }

    downloadArquivoOriginalEmail(nomeArquivo: string, storageInterfaces: boolean, email: string, nomeArquivoOriginal: string) {

        let url = `${env.apiUrlBase}/file/v1/arquivoOriginal`;
        let controleUrl = url.length;
        url = url.concat(`?nomeArquivo=${nomeArquivo}&storageInterfaces=${storageInterfaces ? 'S' : 'N'}&email=${email}&nomeArquivoOriginal=${nomeArquivoOriginal}`)
        return this.http.get(`${url}`).subscribe();

    }
}
